import { useState } from "react";
import classNames from "classnames";
import { Typography } from "../Typography";
import { MessageIcon } from "components/atoms/Icon/MessageIcon";
import { YellowClock } from "components/atoms/Icon/YellowClock";
import { Select } from "components/atoms/Icon/Select";
import { EmptyCircle } from "components/atoms/Icon/EmptyCircle";
import { Modal, OnboardMessageBody, TextEditor } from "components/molecules";
import profileImage from "assets/profileImage.png";
import textIconArrowRight from "assets/text-icon-arrow-right.svg";
import { CloseIcon, Lock } from "../Icon";
import "./index.scss";
import { useAppSelector, useScreenSize } from "hooks";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import { DESKTOP_WIDTH } from "utils/constants";

interface IProps {
  label: string;
  /**If the "icon" property is set to true, the default icon displayed should be the message icon.*/
  icon?: boolean;
  styles?: string;
  isReverse?: boolean;
  iconType?: undefined | "yellow-timer" | "select" | "empty-circle" | "lock" | "arrow-right";
  isTabStyle?: boolean;
  strokeColor?: string;
  onClick?: () => void;
  email?: string;
  badge?: string;
  theme: "light" | "dark";
}

export const TextIcon = ({
  label,
  icon,
  styles,
  isReverse,
  iconType,
  isTabStyle,
  strokeColor,
  onClick,
  email = "",
  badge,
  theme,
}: IProps) => {
  const { aiMCATChatDrawerStatus } = useAppSelector(
    (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
      state.layout
  );
   const screen = useScreenSize();
  return (
    <>
      <div
        className={classNames(
          "text-icon-wrapper",
          { [`${styles}`]: styles },
          isReverse ? "reverse-class" : "non-reverse-class"
        )}
      >
        {badge && badge !== "" ? (
          <div
            className={classNames("text-icon-text", isTabStyle && "tab-text")}
            onClick={onClick}
          >
            <h6
              className={classNames(
                isReverse
                  ? "text-icon-label-reverse"
                  : "text-icon-label-non-reverse"
              )}
            >
              {label}
            </h6>
            <div className="badge-wrapper">
              <h6 className="badge-text">{badge}</h6>
            </div>
          </div>
        ) : (
          <div
            className={classNames("text-icon-text", isTabStyle && "tab-text",screen.width > DESKTOP_WIDTH &&
              screen.width < 1600 &&
              aiMCATChatDrawerStatus === "open" ? "text-icon-text-for-drawer-styles":"")}
            onClick={onClick}
          >
            <h6
              className={classNames(
                isReverse
                  ? "text-icon-label-reverse"
                  : "text-icon-label-non-reverse"
              )}
            >
              {label}
            </h6>
          </div>
        )}
        {icon && (
          <div className={classNames("icon-content")}>
            {iconType === "yellow-timer" ? (
              <YellowClock />
            ) : iconType === "select" ? (
              <Select />
            ) : iconType === "empty-circle" ? (
              <EmptyCircle theme={theme} />
            ) : iconType === "lock" ? (
              <Lock theme={theme} />
            ) : iconType === "arrow-right" ? (
              <img src={textIconArrowRight} alt="" width={16} height={16} />
            ) : (
              <a href={`mailto:${email}`}>
                <MessageIcon onClick={onClick} theme={theme} />
              </a>
            )}
          </div>
        )}
      </div>
    </>
  );
};
